const API_URL = 'https://5jpa6lzug8.execute-api.us-east-1.amazonaws.com/dev/';
const API_URL_PDF = 'http://127.0.0.1:3080/robots/catalogo/convert-pdf-image';
const ID_TOKEN = 'lekacatalogos_token__';
const ID_LAST_ROUTE = 'lekacatalogos_lastroute__';
const ID_CADASTRO_FASE = 'lekacatalogos_fasecadastro__';
export const VERSION = "1.5.3";
export { API_URL, API_URL_PDF, ID_TOKEN, ID_LAST_ROUTE, ID_CADASTRO_FASE };